export const getTimestamp = (date = new Date()) =>
  date
    .toISOString()
    .split('T')
    .join(' ')
    .split('.')[0];
